import { memberImproveRecords, getSellerCheckCode, exportRecord,getUnlockRecord,goodRecords} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { searchInvite } from "@/api/jhk/integralCenter/integralTask";
import echarts from "echarts";
import {
  checkRecord,
  getCouponData,
  getCouponTable,
  checkList,
  awardRecord,
  awardRecNew,
  inKindList,
  exportRecNew,
  improveList,
  signIssuance,
  getShopGiftParticipateConver,
  getSplitCouponlist,
  getStatisticsCouponlist,
  CouponDetail,
  CouponDetailmember,
  commentDraw,
  getExportCode,
  getExportxlxs,
  getExportLockRight,
  getExportLockWin,
  participation,
  gameTaskRecord,
  markDeliveryStatus,
  DeliveryStatus,
  markingSendStatus,
  getActivityRuleFields,
  getSmartDataDetail,
  getSmartDataSum,
  getExchangeActivityRecord,
  splitCouponPage,
  splitCouponGroup,
  splitCouponStatistics,
  groupMember,
  getGoodRecords,
  awardRecNewOne,
  invaidStatics,
  invitationDetailNew,
  addCartpage,
  lockRightRecord,
  lockWinRecord,
  addCartDetail,
  getSumLockEffectJi,
  getDetailLockEffectJi,
  exportJi,
  getDataOverview,
  getDetailPage,
  getExport,
  getWinRecordPage,
  getGoodsRecordPage,
  winRecordExport,
  goodsRecordExport,
  getOrderRecordPage,
  orderRecordPageExport,
  getSumEffect,
  getDetailEffect,
  getDetailIncludeTotal,
  sendSampleRecordExport,
  exportRecord as winnRecord, 
  exportAwardRecord,
  exportInviteCardAwardRecord,
  improveRecordPage,
  exportPlatformImproveRecord
} from "@/api/jhk/integralCenter/PointActivityAnalyticController";
import { 
  checkOrderRecord,
  exportCheckOrderRecord,
  getWinRecord,
  exportWinRecord
} from "@/api/jhk/integralCenter/freeGift"
var pins = ''
export default {
  methods: {
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    export_get(params) {
      this.ExprotData = params;
      this.control2 = true
    },
    getApi_Exprot(exportRemark) {
      // 新逻辑 按记录区分导出，因为一种活动 activityType 可能有多种记录需要导出
      if(this.activeName === 'eighteen'){ // 锁权记录
        let obj = this.$refs.export_fun18.export_fun2();
        let params = {
          ...obj,
          activityId: this.formList.activityId,
          code: this.code,
          current: 1,
          size: 9999999,
        }
        this.formLoading=true;
        getExportLockRight(params).then((res) => {
          this.formLoading=false;
          if (res.code == 1) {
            this.successMsg = "";
            this.dialogExprot = false;
            let Time = new Date().toLocaleString();
            let blob = new Blob([res.blob]);
            let link = document.createElement("a"); //a标签下载
            link.href = window.URL.createObjectURL(blob);
            link.download = "锁权记录" + Time + ".xls";
            link.click();
            window.URL.revokeObjectURL(link.href);
            // }
          } else {
            // this.successMsg = res.message;
            this.$message.warning(res.message);
          }
        });

      }else if(this.activeName === 'seventeen'){ // 发货信息
        let obj = this.$refs.export_fun17.export_fun2();
        let params = {
          ...obj,
          activityId: this.formList.activityId,
          code: this.code,
          current: 1,
          size: 9999999,
          isReceiveInfo:true
        }
        if(this.fitersChooseIF([37])){
          params.subType = '37';
        }
        this.formLoading=true;
        getExportLockWin(params).then((res) => {
          this.formLoading=false;
          if (res.code == 1) {
            this.successMsg = "";
            this.dialogExprot = false;
            let Time = new Date().toLocaleString();
            let blob = new Blob([res.blob]);
            let link = document.createElement("a"); //a标签下载
            link.href = window.URL.createObjectURL(blob);
            link.download = "收货信息" + Time + ".xls";
            link.click();
            window.URL.revokeObjectURL(link.href);
            // }
          } else {
            // this.successMsg = res.message;
            this.$message.warning(res.message);
          }
        });
      }else if(this.activeName === 'sixteen'){ // 积分锁权-中奖记录
        let obj = this.$refs.export_fun16.export_fun2();
        let params = {
          ...obj,
          activityId: this.formList.activityId,
          code: this.code,
          current: 1,
          size: 9999999,
        }
        if(this.fitersChooseIF([37])){
          params.subType = '37';
        }
        this.formLoading=true;
        getExportLockWin(params).then((res) => {
          this.formLoading=false;
          if (res.code == 1) {
            this.successMsg = "";
            this.dialogExprot = false;
            let Time = new Date().toLocaleString();
            let blob = new Blob([res.blob]);
            let link = document.createElement("a"); //a标签下载
            link.href = window.URL.createObjectURL(blob);
            link.download = "中奖名单" + Time + ".xls";
            link.click();
            window.URL.revokeObjectURL(link.href);
            // }
          } else {
            // this.successMsg = res.message;
            this.$message.warning(res.message);
          }
        });
      }else if(this.activeName === 'first' && this.fitersChooseIF([35])){
        let tt = "00:00:00",
        tt1 = "23:59:59"
        let params = {
          // startTime = this.postForm.startDate;
          // endTime = this.postForm.endDat
          startTime: this.postForm.startDate|| "",
          endTime: this.postForm.endDate|| "",
          pin:this.postForm.pin || "",
          activityId: this.formList.activityId,
          code: this.code,
          current: 1,
          size: 9999999,
          channelCode:this.postForm.channelCode
        }
        if (params.startTime.indexOf("00:00:00") != -1 && params.endTime.indexOf("23:59:59") != -1) {
          params.startTime = this.postForm.startDate;
          params.endTime = this.postForm.endDate
        } else{
          params.startTime = this.postForm.startDate + " 00:00:00";
          params.endTime = this.postForm.endDate + " 23:59:59";
        }
        exportJi(params).then((res) => {
          if (res.code == 1) {
            this.successMsg = "";
            this.dialogExprot = false;
            let Time = new Date().toLocaleString();
            let blob = new Blob([res.blob]);
            let link = document.createElement("a"); //a标签下载
            link.href = window.URL.createObjectURL(blob);
            link.download = "活动统计" + Time + ".xls";
            link.click();
            window.URL.revokeObjectURL(link.href);
          } else {
            this.$message.warning(res.message)
          }})    
      }else{
        // 旧逻辑 均按活动 activityType 判断
        let params = {
          ...this.ExprotData,
          activityId: this.formList.activityId,
          current: 1,
          size: 9999999,
          exportRemark,
        };
        if(this.fitersChooseIF([37])){
          params.subType = '37';
        }
        if(this.$route.query.activityType == 33) {
          let obj = this.$refs.export_fun33.export_fun2();
          params = {
            ...obj,
            activityId: this.formList.activityId,
            code: this.code,
            current: 1,
            size: 9999999,
            subType: 33
          }
        }
        // 生日有礼-实物奖品名单-导出
        if(this.rowData.activityType == 39){
          params = {
            activityId: this.formList.activityId,
            pin:this.postForm.pin || "",
            current: 1,
            size: 9999999,
            exportRemark,
            subType: 39
          }
          if(this.formList.memberNick){
            params.memberNick = this.formList.memberNick
          }
          if(this.formList.deliveryTimeStart && this.formList.deliveryTimeEnd){
            params.deliveryTimeStart = this.formList.deliveryTimeStart
            params.deliveryTimeEnd = this.formList.deliveryTimeEnd
          }
          if(this.formList.sendTimeStart && this.formList.sendTimeEnd){
            params.sendTimeStart = this.formList.sendTimeStart
            params.sendTimeEnd = this.formList.sendTimeEnd
          }
          if(this.formList.status){
            params.status = this.formList.status
          }
        }
        getExportxlxs(params).then((res) => {
          if (res.code == 1) {
            this.control2 = true;
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 打榜有礼 导出
    getApi_Exprot2(tabName = 1, exportRemark){
      switch (tabName){
        case 1 : 
          let params = {
            activityId: this.formList.activityId,
            endTime: this.postForm.endDate || "",
            startTime: this.postForm.startDate || "",
            pin:this.postForm.pin || "",
            exportRemark
          };
          if (params.startTime.indexOf("00:00:00") != -1 && params.endTime.indexOf("23:59:59") != -1) {
            params.startTime = this.postForm.startDate;
            params.endTime = this.postForm.endDate
          } else{
            params.startTime = this.postForm.startDate + " 00:00:00";
            params.endTime = this.postForm.endDate + " 23:59:59";
          }
          getExport(params).then((res) => {
            if(res.code == 1){
              this.control3 = true
            }else {
              this.$message.error(res.message)
            }}
          ).catch(() => {
            this.$message.error(res.code)
          })
          break;
        case 2: 
          // 查询列表
          let formObj2 = this.$refs.export_fun_lj2.export_fun2();
          let pamams2 = {
            ...formObj2,
            id: this.formList.activityId,
            exportRemark,
          }
          winRecordExport(pamams2).then((res) => {
            if(res.code == 1){
              this.control3 = true;
            }else {
              this.$message.error(res.message)
            }}
          ).catch(() => {
            this.$message.error(res.message)
          })
          break;
        case 3: 
          // 查询列表
          let formObj3 = this.$refs.export_fun_sw2.export_fun2();
          let pamams3 = {
            ...formObj3,
            activityId: this.formList.activityId,
            exportRemark,
          }
          goodsRecordExport(pamams3).then((res) => {
            if(res.code == 1){
              this.control3 = true;
            }else {
              this.$message.error(res.message)
            }}
          ).catch(() => {
            this.$message.error(res.code)
          })
          break;
      }
      
    },
    // 派样回购礼 导出
    getApi_Exprot3(tabName = 1){
      switch (tabName){
        case 1 : 
          // 活动统计
          let params = {
            activityId: this.formList.activityId,
            code: this.code,
            endTime: this.postForm.endDate || "",
            startTime: this.postForm.startDate || "",
            pin:this.postForm.pin || "",
            current: 1,
            type: 1,
            size: 9999999,
          };
          if (params.startTime.indexOf("00:00:00") != -1 && params.endTime.indexOf("23:59:59") != -1) {
            params.startTime = this.postForm.startDate;
            params.endTime = this.postForm.endDate
          } else{
            params.startTime = this.postForm.startDate + " 00:00:00";
            params.endTime = this.postForm.endDate + " 23:59:59";
          }
          sendSampleRecordExport(params).then((res) => {
            if(res.code == 1){
              this.dialogExprot = false;
              const href = URL.createObjectURL(res.blob)
              const a = document.createElement('a')
              a.style.display = "none";
              a.setAttribute("href", href);
              a.download = res.fileName;
              document.body.appendChild(a);
              a.click();
              a.remove();
              URL.revokeObjectURL(href);
            }else {
              this.$message.error("导出失败")
            }}
          ).catch(() => {
            this.$message.error(res.code)
          })
          break;
        case 2: 
          // 派样下单记录
          let params2 = {
            ...this.formList,
            activityId: this.formList.activityId,
            code: this.code,
            current: 1,
            type: 0,
            size: 9999999,
          }
          orderRecordPageExport(params2).then((res) => {
            if(res.code == 1){
              this.dialogExprot = false;
              const href = URL.createObjectURL(res.blob)
              const a = document.createElement('a')
              a.style.display = "none";
              a.setAttribute("href", href);
              a.download = res.fileName;
              document.body.appendChild(a);
              a.click();
              a.remove();
              URL.revokeObjectURL(href);
            }else {
              this.$message.error("导出失败")
            }}
          ).catch(() => {
            this.$message.error(res.code)
          })
          break;
        case 3: 
          let params3 = {
            ...this.formList,
            activityId: this.formList.activityId,
            code: this.code,
            current: 1,
            size: 9999999,
            type: 1,
          }
          orderRecordPageExport(params3).then((res) => {
            if(res.code == 1){
              this.dialogExprot = false;
              const href = URL.createObjectURL(res.blob)
              const a = document.createElement('a')
              a.style.display = "none";
              a.setAttribute("href", href);
              a.download = res.fileName;
              document.body.appendChild(a);
              a.click();
              a.remove();
              URL.revokeObjectURL(href);
            }else {
              this.$message.error("导出失败")
            }}
          ).catch(() => {
            this.$message.error(res.code)
          })
          break;
      }
    },
    // 返回value
    fitersTypeValue(val) {
      let arr = ["", "每日打卡", "浏览店铺", "浏览商品", "加购商品", "浏览会场", "关注店铺", "开卡入会", "好友助力"];
      return arr[val];
    },
    // 抽奖机会赠送记录-大转盘
    fitersTypeValue2(val) {
      let arr = [
        { label: '每日签到', value:1},
        { label: '浏览店铺', value:2},
        { label: '浏览商品', value:13},
        { label: '加购商品', value:4 },
        { label: "分享商品", value: 9 },
        { label: "分享店铺", value: 10 },
        { label: "分享活动", value: 11 },
        { label: "好友助力", value: 8 },
        { label: "浏览会场", value: 5 },
        { label: "预约商品", value: 12 },
        { label: '首次赠送', value: 14 },
        { label: '每日赠送', value: 15 },
        { label: '积分兑换', value: 16 },
        { label: '购买商品', value: 17 },
        { label: '手动变更', value: 19 },
      ];
      const index = arr.findIndex(item=>item.value == val)
      if(index != -1){
        return arr[index].label
      }else{
        return ""
      }
    },
    // 抽奖机会赠送记录-大转盘-赠送记录
    fitersTypeValue3(row) {
      let str = '';
      let arr = [];
      if(row.orderList) {
        row.orderList.forEach(item => {
          arr.push(item.orderId);
        })
      }
      str = arr.join(',');
      return str;
    },
    // 抽奖机会赠送记录-大转盘-赠送记录
    fitersTypeValue4(row) {
      let arr = [];
      if(row.orderList) {
        row.orderList.forEach(item => {
          arr.push(`订单号：${item.orderId},订单金额：${item.price}元,订单状态：${item.orderState}`);
        })
      }
      return arr;
    },
    // 活动类型 三元表达式 判断显示文字
    fitersRepurchase(arr, val1, val2) {
      let isfaly = false;
      arr.forEach((item) => {
        if (this.rowData.activityType == item) {
          isfaly = true;
        }
      });
      return isfaly ? val1 : val2;
    },
    // this.rowData.activityType活动类型判断显示隐藏type === "=="则arr里面显示,type === "！="   则arr里面不显示
    fitersChooseIF(arr, type = "==") {
      if (type === "==") {
        let isfaly = false;
        arr.forEach((item) => {
          if (this.rowData.activityType == item) {
            isfaly = true;
          }
        });
        return isfaly;
      } else {
        let isfaly = true;
        arr.forEach((item) => {
          if (this.rowData.activityType == item) {
            isfaly = false;
          }
        });
        return isfaly;
      }
    },
    //下单转化数据
    getShopGiftParticipateConver() {
      let tt = "00:00:00",
        start = "",
        end = "",
        startTime = "",
        endTime = "",
        tt1 = "23:59:59"
        ;
      if (this.queryForm.evaluateTime == 0) {
        if (this.postForm.startDate == "" || this.postForm.endDate == "") {
          this.$message({
            message: "自定义时间不能为空！",
            type: "warning",
          });
          return;
        }
        start = `${this.postForm.startDate} ${tt}`;
        end = `${this.postForm.endDate} ${tt1}`;
      }
      if (this.queryForm.evaluateTime == 0) {
        startTime = start;
        endTime = end;
      } else {
        startTime = this.postForm.startDate;
        endTime = this.postForm.endDate;
      }
      getShopGiftParticipateConver({
        activityId: this.formList.activityId,
        startTime,
        endTime,
        source:this.fitersChooseIF([9,10,29,30,38]) ? 2 : 1,
      })
        .then((res) => {
          if (res.code == 1) {
            this.tatal_num = res.data;
          } else {
            this.$message({
              message: res.data.message,
              type: "warning",
            });
            this.tatal_num = {
              gmv: 0,
              newShopGmv: 0,
              newShopUsers: 0,
              ordNum: 0,
              ordRate: 0,
              users: 0,
            };
          }
        })
        .catch(() => {});
    },
    //返回列表
    toSetting() {
      this.$emit("returnStep");
    },
    //页头点击
    async handleClick(tab, event) {
      this.$nextTick(()=>{
        let dom = document.querySelector(".app-content-main-topBox")?document.querySelector(".app-content-main-topBox"):document.querySelector(".el-main")
        if(dom){
          dom.scrollTop = 0
        }
      })
      this.formList.size = 10;
      this.formList.current = 1;
      // this.totalMail = 0
      this.multipleSelection = [];
      this.tabName = tab.name;
      this.actTab = tab;
      // 活动统计
      if (tab.name === "first") {
        this.queryOne();
        // await this.queryTotal();
        this.getShopGiftParticipateConver();
      }
      // 解锁纪录
      if (tab.name === "unlock") {
        // this.$refs.unlockRef.initVal();
        this.$nextTick(()=>{
        this.$refs.unlockRef.reData();
        this.formList = {
          pin: "",
          giveType: "",
          orderId: "",
          orderState: "",
          isCommitAddress: "",
          isWin: "",
          startTime: null,
          endTime: null,
          finishStartTime: null,
          finishEndTime: null,
          current: this.formList.current,
          size: this.formList.size,
          activityId: this.formList.activityId,
          venderId:this.loginUserInfo.venderId,
        }
        this.searchUnlockRecord();
        })
      }
      // 赠品记录
      if (tab.name === "gift") {
        // this.$refs.giftRef.initVal();
        this.$nextTick(()=>{
        this.$refs.giftRef.reData();
        this.formList = {
          pin: "",
          giveType: "",
          orderId: "",
          prizeType: "",
          prizeName: "",
          sendStatus: "",
          deliveryStatus: "",
          joinTimeStart: null,
          joinTimeEnd: null,
          sendStartTime: null,
          sendEndTime: null,
          deliveryTimeStart: null,
          deliveryTimeEnd: null,
          current: this.formList.current,
          size: this.formList.size,
          activityId: this.formList.activityId,
          venderId:this.loginUserInfo.venderId,
        }
        this.searchGiftRecord();
        })
      }
      //收货信息
      if(tab.name === "recept"){
        // this.$refs.receptRef.initVal();
        this.$nextTick(()=>{
        this.$refs.receptRef.reData();
        this.formList = {
          pin: "",
          inputTimeStart: "",
          inputTimeEnd: "",
          isReceiveInfo: true, //是否收货信息栏目
          current: this.formList.current,
          size: this.formList.size,
          activityId: this.formList.activityId,
          venderId:this.loginUserInfo.venderId,
        }
        this.searchReceptRecord();
        })
      }
      if(tab.name === "participateRecord"){
        this.$nextTick(()=>{
        this.$refs.participateRef.reData();
        this.formList = {
          pin: "",
          memberNick: "",
          startTime: "",
          endTime: "",
          current: 1,
          size: 10,
          activityId: this.formList.activityId,
          venderId:this.loginUserInfo.venderId,
        }
        this.getParticipateRecord();
        })
      }
      // AI趣答-参与记录
      if (tab.name === "aiParticipateRecord") {
        this.$nextTick(() => {
          this.getParticipateRecordList();
        });
      }
      if(tab.name === "winnRecord"){
        this.$nextTick(()=>{
        this.$refs.inputAwardOneRef.reData();
        this.formList = {
          pin: "",
          memberNick: "",
          status: "",
          startTime: "",
          endTime: "",
          prizeType: "",
          current: 1,
          size: 10,
          activityId: this.formList.activityId,
          venderId:this.loginUserInfo.venderId,
        }
        this.winningRecord();
        })
      }
      if(tab.name === "physicalPrizes"){
        this.$nextTick(()=>{
        this.$refs.export_fun_swRef.reData();
        this.formList = {
          pin: "",
          memberNick: "",
          startTime: '',
          endTime: '',
          status: '',
          orderId: '',
          orderState: '',
          commitAddressFlag: '',
          current: 1,
          size: 10,
          activityId: this.formList.activityId,
          venderId:this.loginUserInfo.venderId,
        }
        this.inKingRecord();
        })
      }
      if(tab.name === "giveRecord"){
        this.$nextTick(()=>{
        this.$refs.export_fun_swRef.reData();
        this.formList = {
          pin: "",
          memberNick: "",
          taskType: "",
          startTime: "",
          endTime: "",
          current: 1,
          size: 10,
          activityId: this.formList.activityId,
          venderId:this.loginUserInfo.venderId,
        }
        this.getGameTaskRecord();
        })
      }
      // 入会用户转化分析
      if (tab.name == "conversionAnalysis") {
        this.conversionPage = {
          size: 10,
          current: 1,
          total: 0,
        };
        this.searchConversion({
          openCardStartTime: this.getDateStr(-30) + " 00:00:00",
          openCardEndTime: this.getDateStr(0) + " 23:59:59"
        });
      }
      // 穿搭人格推荐
      if (tab.name === "personality") {
        this.$nextTick(() => {
          this.getPersonalityList();
        });
      }
      // 抽奖记录
      if (tab.name === "lotteryRecord") {
        this.$nextTick(() => {
          this.getLotteryRecordList();
        });
      }
      // 商品推荐明细
      if (tab.name === "productRecommend") {
        this.$nextTick(() => {
          this.getProductRecommendList();
        });
      }
    },
    timeChange(type,index) {
      this.queryForm.evaluateTime = type;
      this.defaultIndex = index;
      if (type == null) {
        let time = this.$getActDate(7, this.rowData.startTime);
        this.postForm.startDate = time[0].substring(0, 10) + " 00:00:00";
        this.postForm.endDate = time[1].substring(0, 10) + " 23:59:59";
      } else if (type == 7) {
        let time = this.$getActDate(7, this.rowData.startTime);
        this.postForm.startDate = time[0].substring(0, 10) + " 00:00:00";
        this.postForm.endDate = time[1].substring(0, 10) + " 23:59:59";
      } else if (type == 15) {
        let time = this.$getActDate(15, this.rowData.startTime);
        this.postForm.startDate = time[0].substring(0, 10) + " 00:00:00";
        this.postForm.endDate = time[1].substring(0, 10) + " 23:59:59";
      } else if (type == 30) {
        let time = this.$getActDate(30, this.rowData.startTime);
        this.postForm.startDate = time[0].substring(0, 10) + " 00:00:00";
        this.postForm.endDate = time[1].substring(0, 10) + " 23:59:59";
      } else {
        this.postForm.startDate = "";
        this.postForm.endDate = "";
      }
    },
    //时间限制
    clearTimeSendTime() {
      this.postForm.startDate = "";
      this.postForm.endDate = "";
    },
    // 查询按钮
    querySeach() {
      this.formList.current = 1;
      this.formList.size = 10;
      this.queryTotal();
      this.getShopGiftParticipateConver();
    },
    //查询数据总和
    async queryTotal() {
      let tt = "00:00:00",
        start = "",
        end = "",
        startTime = "",
        endTime = "",
        tt1 = "23:59:59";
      if (this.queryForm.evaluateTime == 0) {
        if (this.postForm.startDate == "" || this.postForm.endDate == "") {
          this.$message({
            message: "自定义时间不能为空！",
            type: "warning",
          });
          return;
        }
        start = `${this.postForm.startDate} ${tt}`;
        end = `${this.postForm.endDate} ${tt1}`;
      }
      if (this.queryForm.evaluateTime == 0) {
        startTime = start;
        endTime = end;
      } else {
        startTime = this.postForm.startDate;
        endTime = this.postForm.endDate;
      }
      // 获取数据汇总
      getCouponData({
        activityId: this.formList.activityId,
        startTime,
        endTime,
        source:this.fitersChooseIF([9,10,29,30,38]) ? 2 : 1
      }).then((res) => {
        this.loading = false;
        // 数据总览数据
        this.tableTotal = res.data;
      });
      // 获取数据明细
      checkRecord({
        activityId: this.formList.activityId,
        startTime,
        endTime,
        source:this.fitersChooseIF([9,10,29,30,38]) ? 2 : 1
      }).then((res) => {
          // 折线图数据
          this.chartEffectDetail = res.data;
          this.$nextTick(() => {
            this.initChart();
            window.addEventListener("resize", () => {
              this.myCharts.resize();
            });
          });
      });
    },
    //折线图
    initChart() {
      if (this.rowData.activityType != 15) {
        if(!this.myCharts){
          this.myCharts = echarts.init(this.$refs.payRemindChart);
        }else{
          this.myCharts.clear()
        }
        this.setOptions();
      }
    },
    //折线图事件
    setOptions() {
      const seriesList = this.dataSummary.map((item) => {
        return {
          name: item.name,
          type: "line",
          smooth: true,
          color: item.color,
          // 无数据显示0处理
          data: this.chartEffectDetail.map((i) => i[item.value]?i[item.value]: 0),
        };
      });
      let option = {
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            return this.echartIcon(params);
          }
        },
        legend: {
          data: this.dataSummary.map((item) => item.name),
          bottom: -5,
          left: "center",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: this.fitersChooseIF([37])? "16%" :"11%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data:this.fitersChooseIF([35, 36, 37])?this.chartEffectDetail.map((item) => item.statsDate):this.chartEffectDetail.map((item) => item.dateTime),
        },
        yAxis: {
          type: "value",
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: seriesList,
      };

      this.myCharts.setOption(option);
    },
    //重置
    queryOne() {
      this.formList.current = 1;
      this.formList.size = 10;
      this.queryForm.evaluateTime = "7";
      this.queryForm.channelCode = "";
      this.timeChange(7);
      this.queryTotal();
    },
    // 参与记录
    getParticipation() {
      this.loading = true;
      participation(this.formList)
        .then((res) => {
          this.loading = false;
          this.ParticipatTable = res.data.records;
          this.totalParticipat = Number(res.data.total);
        })
        .catch((res) => {});
    },
    //参与赠送
    getGameTaskRecord() {
      this.loading = true;
      gameTaskRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.GiftrecordList = res.data.records;
          this.totalGiftrecord = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 抽奖机会赠送 查看详情
    commentDetails(item) {
      this.commentItem = item;
      this.commentDioag = true;
    },
    dialogClose() {
      this.commentDioag = false;
    },
    // 团队详情 查看详情
    async viewDetails(item) {
      if (this.fitersChooseIF([31])) {
        const { data: res } = await groupMember(item.id)
        this.CouponMember = res.map((item, i) => {
          return {
            ...item,
            // group: i == 0 ? "团长" : "团员",
          };
        });
      } else {
        const { data: res } = await CouponDetailmember(item.id);
        this.CouponMember = res.map((item, i) => {
          return {
            ...item,
            group: i == 0 ? "团长" : "团员",
          };
        });
      }
      this.dialogGroup = true;
    },
    //签到记录
    checkRecord() {
      this.loading = true;
      console.log(this.formList,'554455445545454');
      
      checkList(this.formList)
        .then((res) => {
          this.loading = false;
          this.signInTable = res.data.records;
          this.totalSignIn = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 加购记录
    addCartpage(){
      this.loading = true;
      addCartpage(this.formList).then((res)=>{
        this.loading = false
        this.addCartTable = res.data.records
        this.totalAddCart = Number(res.data.total)
      }).catch((res) => {
      });
    },
    // 锁权记录
    lockRightRecord(){
      this.loading = true;
      lockRightRecord(this.formList).then((res)=>{
        this.loading = false
        this.lockRightTable = res.data.records
        this.totalLockRight = Number(res.data.total)
      }).catch((res) => {
      });
    },
    // 收货信息
    takeGoodsRecord(){
      this.loading = true;
      let params = {
        ...this.formList,isReceiveInfo:true
      }
      if(this.fitersChooseIF([37])){
        params.subType ='37'
      }
      //isReceiveInfo 是否为收货信息 true收货信息 空或不传为 积分锁权-中奖记录
      lockWinRecord(params).then((res)=>{
        this.loading = false
        this.takeGoodsTable = res.data.records
        this.totalTakeGoods = Number(res.data.total)
      }).catch((res) => {
      });
    },
    //中奖记录
    winningRecord() {
      this.loading = true;
      // 只有邀请类的调awardRecNew接口
      if (this.rowData.activityType == 6) {
        awardRecNew(this.formList)
          .then((res) => {
            this.loading = false;
            this.awardTable = res.data.records;
            this.totalAward = Number(res.data.total);
          })
          .catch((res) => {});
      }else if(this.rowData.activityType == 5){  //Note---邀请开卡有礼中奖纪录接口修改 
        awardRecNewOne(this.formList)
          .then((res) => {
            this.loading = false;
            this.awardTable = res.data.records;
            this.totalAward = Number(res.data.total);
         })
        .catch((res) => {});
      }else if (this.rowData.activityType == 33) {
        this.formList.subType = 33
        getGoodRecords(this.formList).then(res=>{
          this.loading = false;
          this.awardTable = res.data.records;
          this.totalAward = Number(res.data.total);
        })
      }else if (this.rowData.activityType == 35){
        // 积分锁权 中奖记录
        lockWinRecord(this.formList).then(res=>{
          this.loading = false;
          this.awardTable = res.data.records;
          this.totalAward = Number(res.data.total);
        })
      }else if (this.rowData.activityType == 37){
        let params = {
          subType: "37",
          ...this.formList
        }
        // 派样回购礼
        lockWinRecord(params).then(res=>{
          this.loading = false;
          this.awardTable = res.data.records;
          this.totalAward = Number(res.data.total);
        })
      }else {
        awardRecord(this.formList)
          .then((res) => {
            this.loading = false;
            this.awardTable = res.data.records;
            this.totalAward = Number(res.data.total);
          })
          .catch((res) => {});
      }
    },
    //发放记录 为中奖记录的接口awardRecord
    distributionRecord() {
      this.loading = true;
      // awardRecNew(this.formList)
      awardRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.distributionTable = res.data.records;
          this.totalDistribution = Number(res.data.total);
        })
        .catch((res) => {});
    },
    //导出
    exportTheData(exportRemark) {  
      // var formDate = JSON.parse(sessionStorage.getItem('exportForm'))
      var formDate = this.formList;
      if (this.rowData.activityType == 6) {
        let param = this.formList.activityId;
        const params = {
          activityId: encodeURI(param),
          current: formDate.current,
          size: formDate.size,
          endTime: formDate.endTime ? formDate.endTime : "",
          startTime: formDate.startTime ? formDate.startTime : "",
          prizeType: formDate.prizeType ? formDate.prizeType : "",
          status: formDate.status ? formDate.status : "",
          memberNick: formDate.memberNick ? formDate.memberNick : "",
          orderState: formDate.orderState ? formDate.orderState : "",
          unlockOrderId: formDate.unlockOrderId ? formDate.unlockOrderId : "",
          pin:formDate.pin ? formDate.pin :"",
          exportRemark,
        }
        exportRecNew(params).then((res) => {
          if(res.code == 1){
            this.control1 = true;
          }else{
            this.$message.error(res.message);
          }
        })
      }else if(this.rowData.activityType == 5){
        let param = this.formList.activityId;
        const params = {
          activityId: encodeURI(param),
          current: formDate.current,
          size: formDate.size,
          endTime: formDate.endTime ? formDate.endTime : "",
          startTime: formDate.startTime ? formDate.startTime : "",
          prizeType: formDate.prizeType ? formDate.prizeType : "",
          status: formDate.status ? formDate.status : "",
          memberNick: formDate.memberNick ? formDate.memberNick : "",
          orderState: formDate.orderState ? formDate.orderState : "",
          unlockOrderId: formDate.unlockOrderId ? formDate.unlockOrderId : "",
          pin:formDate.pin ? formDate.pin :"",
          exportRemark,
        }
        exportInviteCardAwardRecord(params).then((res) => {
          if(res.code == 1){
            this.control1 = true;
          }else{
            this.$message.error(res.message);
          }
        })
      } else if (
        this.rowData.activityType == 16 ||
        this.rowData.activityType == 17 ||
        this.rowData.activityType == 18 ||
        this.rowData.activityType == 19
      ) {
        let param = this.formList.activityId;
        const params = {
          activityId: encodeURI(param),
          current: formDate.current,
          size: formDate.size,
          endTime: formDate.endTime ? formDate.endTime : "",
          startTime: formDate.startTime ? formDate.startTime : "",
          prizeType: formDate.prizeType ? formDate.prizeType : "",
          status: formDate.status ? formDate.status : "",
          memberNick: formDate.memberNick ? formDate.memberNick : "",
          orderState: formDate.orderState ? formDate.orderState : "",
          unlockOrderId: formDate.unlockOrderId ? formDate.unlockOrderId : "",
          pin:formDate.pin ? formDate.pin :"",
          exportRemark,
        }
        // 下单抽奖-添加白名单字段
        if(this.rowData.activityType == 19){
          params.isWhite = formDate.isWhite
        }
        exportAwardRecord(params).then((res) => {
          if(res.code == 1){
            this.control1 = true;
          }else{
            this.$message.error(res.message);
          }
        })
      } else if(this.rowData.activityType == 33) {
        let param = this.formList.activityId;
        let elem = document.createElement("a");
        elem.style.display = "none";
        let url = `/jd-hd-web/PointActivityEffectDetails/exportGoodRecords?activityId=${encodeURI(param)}&current=${formDate.current}&size=${formDate.size}&endTime=${formDate.endTime?formDate.endTime:''}&startTime=${formDate.startTime?formDate.startTime:''}&prizeType=${formDate.prizeType?formDate.prizeType:''}&status=${formDate.status?formDate.status:''}&memberNick=${formDate.memberNick?formDate.memberNick:''}&orderState=${formDate.orderState?formDate.orderState:''}&unlockOrderId=${formDate.unlockOrderId?formDate.unlockOrderId:""}&pin=${formDate.pin?formDate.pin:""}`;
        elem.href = url;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }else if(this.rowData.activityType == 39){
        let param = this.rowData.id;
        let elem = document.createElement("a");
        elem.style.display = "none";
        let url = `/jd-hd-web/PointActivityEffectDetails/exportPointActivityPrizeDetail?activityId=${param}&current=${this.formListRecord.current}&size=${this.formListRecord.size}&endTime=${this.formListRecord.endTime?this.formListRecord.endTime:''}&startTime=${this.formListRecord.startTime?this.formListRecord.startTime:''}&prizeType=${this.formListRecord.prizeType?this.formListRecord.prizeType:''}&status=${this.formListRecord.status?this.formListRecord.status:''}&memberNick=${this.formListRecord.memberNick?this.formListRecord.memberNick:''}&pin=${this.formListRecord.pin?this.formListRecord.pin:""}`;
        elem.href = url;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }else {
        let param = this.formList.activityId;
        const params = {
          activityId: encodeURI(param),
          current: formDate.current,
          size: formDate.size,
          endTime: formDate.endTime ? formDate.endTime : "",
          startTime: formDate.startTime ? formDate.startTime : "",
          prizeType: formDate.prizeType ? formDate.prizeType : "",
          status: formDate.status ? formDate.status : "",
          memberNick: formDate.memberNick ? formDate.memberNick : "",
          orderState: formDate.orderState ? formDate.orderState : "",
          unlockOrderId: formDate.unlockOrderId ? formDate.unlockOrderId : "",
          pin:formDate.pin ? formDate.pin :"",
          exportRemark,
        }
        winnRecord(params).then((res) => {
          if(res.code == 1){
            this.control1 = true;
          }else{
            this.$message.error(res.message);
          }
        })
      }
    },
    //实物奖品
    inKingRecord() {
      this.loading = true;
      inKindList(this.formList)
        .then((res) => {
          this.loading = false;
          this.totalInkind = Number(res.data.total);
          this.inkindTable = res.data.records.map(item => {
            return {
              ...item
            }
          });
        })
        .catch((res) => {});
    },
    //资料明细
    improveRecord() {
      this.loading = true;
      improveList(this.formList)
        .then((res) => {
          this.loading = false;
          this.userInfoTable = res.data.records;
          this.totalUserInfo = Number(res.data.total);
        })
        .catch((res) => {});
    },
    //标记状态
    markIss(row) {
      signIssuance({ id: row.recordId || row.id })
        .then((res) => {
          if (res && res.code == 1) {
            if(this.tabName == "twenty-one"){
              // 打榜有礼的
              this.getWinRecord();
            }else {
              // 实物奖品名单不需要获取积分相关接口，暂时这样处理
              if(this.tabName != 'four') {
                this.winningRecord();
              }
              this.inKingRecord();
            }
            this.$message.success(res.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((res) => {});
    },
    // 抽奖机会赠送
    commentDraw() {
      this.loading = true;
      commentDraw(this.formList)
        .then((res) => {
          this.loading = false;
          this.CommentList = res.data.records;
          this.totalComment = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 拼券明细
    CoupondDtails() {
      this.loading = true;
      
      if (this.fitersChooseIF([21])) {
        getSplitCouponlist(this.formList)
        .then((res) => {
          this.loading = false;
          this.couponDetailsList = res.data.records;
          this.totalCoupon = Number(res.data.total);
        })
      } else {
        splitCouponPage(this.formList)
        .then((res) => {
          this.loading = false;
          this.couponDetailsList = res.data.records;
          this.totalCoupon = Number(res.data.total);
        })
      }
    },
    // 优惠券统计
    CouponStatistics() {
      this.loading = true;
      if (this.fitersChooseIF([21])) {
          getStatisticsCouponlist(this.formList)
        .then((res) => {
          this.loading = false;
          this.CouponStatisticsList = res.data.records.map((item, index) => {
            let obj = item;
            obj.id = index + "@10";
            let num = index++;
            if (obj.data.length != 0) {
              obj.data.forEach((ele, i) => {
                ele.id = num + new Date();
              });
            }
            return obj;
          });
          this.totalCouponstatistics = Number(res.data.total);
        })
      } else {
        splitCouponStatistics(this.formList)
        .then((res) => {
          this.loading = false;
          this.CouponStatisticsList = res.data.map((item, index) => {
            let obj = item;
            obj.id = index + "@1@";
            return obj;
          });
        })
        }
    },
    // 团队详情
    TeamDetails() {
      this.loading = true;
      if (this.fitersChooseIF([31])) {
        splitCouponGroup(this.formList)
        .then((res) => {
          this.loading = false;
          this.TeamDetailsList = res.data.records;
          this.totalTeam = Number(res.data.total);
        })
      } else {
        CouponDetail(this.formList)
        .then((res) => {
          this.loading = false;
          this.TeamDetailsList = res.data.records;
          this.totalTeam = Number(res.data.total);
        })
      }
    },
    // 信息参与记录查询
    searchParticipate(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.getParticipateRecord()
    },
    // 信息参与记录
    getParticipateRecord() {
      this.loading = true;
      improveRecordPage(this.formList)
        .then((res) => {
          this.loading = false;
          this.participateTable = res.data.records;
          this.totalParticipate = Number(res.data.total);
        })
        .catch((res) => {});
    },
    handleParticipate(page) {
      this.formList.current = page.pageNum
      this.formList.size = page.pageSize
      this.getParticipateRecord();
    },
    //分页事件
    handlePage(val){
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.queryTotal();
    },
    handleSizeChange(val) {
      this.formList.size = val;
      this.queryTotal();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.queryTotal();
    },
    handleSizeSignIn(val) {
      this.formList.size = val;
      this.checkRecord();
    },
    handleCurrentSignIn(val) {
      this.formList.current = val;
      this.checkRecord();
    },
    handleSizeAddCart(val) {
      this.formList.size = val;
      this.addCartpage();
    },
    handleCurrentAddCart(val) {
      this.formList.current = val;
      this.addCartpage();
    },
    handleSizeLockRight(val) {
      this.formList.size = val;
      this.lockRightRecord();
    },
    handleCurrentLockRight(val) {
      this.formList.current = val;
      this.lockRightRecord();
    },
    handleSizeTakeGoods(val) {
      this.formList.size = val;
      this.takeGoodsRecord();
    },
    handleCurrentTakeGoods(val) {
      this.formList.current = val;
      this.takeGoodsRecord();
    },
    // 参与记录
    handleSizeParticipat(val) {
      this.formList.size = val;
      this.getParticipation();
    },
    handleCurrentParticipat(val) {
      this.formList.current = val;
      this.getParticipation();
    },
    handleSizeAward(val) {
      this.formList.size = val;
      this.winningRecord();
    },
    handleSizeAward1(val){
      this.formList.size = val;
      this.statistics()
    },
    handleSizeAwardOne(val) {
      this.formList.size = val;
      this.distributionRecord();
    },
    handleCurrentAward(val) {
      this.formList.current = val;
      this.winningRecord();
    },
    handleCurrentAward1(val){
      this.formList.current = val;
      this.statistics();
    },
    handleCurrentAwardOne(val) {
      this.formList.current = val;
      this.distributionRecord();
    },
    handleSizeInkind(val) {
      this.formList.size = val;
      this.inKingRecord();
    },
    handleCurrentInkind(val) {
      this.formList.current = val;
      this.inKingRecord();
    },
    handleSizeUserInfo(val) {
      this.formList.size = val;
      this.improveRecord();
    },
    handleCurrentUserInfo(val) {
      this.formList.current = val;
      this.improveRecord();
    },
    // 抽奖机会赠送
    handleSizeComment(val) {
      this.formList.size = val;
      this.commentDraw();
    },
    handleCurrentComment(val) {
      this.formList.current = val;
      this.commentDraw();
    },
    // 拼券明细
    handleSizeCoupond(val) {
      this.formList.size = val;
      this.CoupondDtails();
    },
    handleCurrentCoupond(val) {
      this.formList.current = val;
      this.CoupondDtails();
    },
    // 优惠券统计
    handleSizeCouponStatistics(val) {
      this.formList.size = val;
      this.CouponStatistics();
    },
    handleCurrentCouponStatistics(val) {
      this.formList.current = val;
      this.CouponStatistics();
    },
    // 团队详情
    handleSizeTeam(val) {
      this.formList.size = val;
      this.TeamDetails();
    },
    handleCurrentTeam(val) {
      this.formList.current = val;
      this.TeamDetails();
    },
    // 赠送记录
    handleSizeGiftrecord(val) {
      this.formList.size = val;
      this.getGameTaskRecord();
    },
    handleCurrentGiftrecord(val) {
      this.formList.current = val;
      this.getGameTaskRecord();
    },
    //签到查询
    searchForm(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.checkRecord();
    },
    // 加购记录查询
    searchAddCart(val){
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.isWin = val.isWin;
      this.formList.pin = val.pin;
      this.addCartpage()
    },
    //参与记录查询
    searchParticipationForm(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.startScore = val.startScore;
      this.formList.endScore = val.endScore;
      this.formList.isPass = val.isPass;
      this.formList.isDraw = val.isDraw;
      this.formList.isWin = val.isWin;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.pin = val.pin;
      this.getParticipation();
    },
    searchAward(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      
      this.distributionRecord();
    },
    // 派样下单记录查询方法
    searchSendBuyPay(val){
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.skuId = val.skuId;
      this.formList.skuName = val.skuName;
      this.formList.orderId = val.orderId;
      this.formList.isCommitAddress = val.isCommitAddress;
      this.formList.orderTimeStart = val.orderTimeStart;
      this.formList.orderTimeEnd = val.orderTimeEnd;
      this.formList.receiveTimeStart = val.receiveTimeStart;
      this.formList.receiveTimeEnd = val.receiveTimeEnd;
      this.getSendBuyPayData();
    },
    // 派样下单记录列表查询方法
    getSendBuyPayData(){
      this.loading = true;
      this.formList.id = this.formList.activityId;
      // 派样传type 为 0
      let params = {
        ...this.formList,
        type: 0,
      }
      // 发送请求
      getOrderRecordPage(params).then(res => {
        this.sendBuyPayTable =[];
        if(res.code == 1){
          this.sendBuyPayTable = res.data.records;
          this.totalSendBuyPayCount = Number(res.data.total);
          this.formList.current = Number(res.data.current);
          this.loading = false;
        }else {
          this.$message.error(res.message);
          this.loading = false;
        }
      }).catch(err => {
        this.$message.error(err);
        this.loading = false;
      })
    },
    handleCurrentSendBuyPay(val) {
      this.formList.current = val;
      this.getSendBuyPayData();
    },
    handleSizeSendBuyPay(val) {
      this.formList.size = val;
      this.getSendBuyPayData();
    },
    // 回购下单记录查询方法
    searchSendBuyRePay(val){
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.skuId = val.skuId;
      this.formList.skuName = val.skuName;
      this.formList.orderId = val.orderId;
      this.formList.orderPaymentStart = val.orderPaymentStart;
      this.formList.orderPaymentEnd = val.orderPaymentEnd;
      this.formList.isWin = val.isWin;
      this.formList.isCommitAddress = val.isCommitAddress;
      this.formList.orderTimeStart = val.orderTimeStart;
      this.formList.orderTimeEnd = val.orderTimeEnd;
      this.formList.receiveTimeStart = val.receiveTimeStart;
      this.formList.receiveTimeEnd = val.receiveTimeEnd;
      this.getSendBuyRePayData();
    },
    // 回购下单记录列表查询方法
    getSendBuyRePayData(){
      this.loading = true;
      this.formList.id = this.formList.activityId;
      // 复购传type 为 1
      let params = {
        ...this.formList,
        type: 1,
      }
      // 发送请求
      getOrderRecordPage(params).then(res => {
        this.sendBuyRePayTable =[];
        if(res.code == 1){
          this.sendBuyRePayTable = res.data.records;
          this.totalSendBuyRePayCount = Number(res.data.total);
          this.formList.current = Number(res.data.current);
          this.formList.size = Number(res.data.size);
          this.loading = false;
        }else {
          this.$message.error(res.message);
          this.loading = false;
        }
      }).catch(err => {
        this.$message.error(err);
        this.loading = false;
      })

    },
    handleCurrentSendBuyRePay(val) {
      this.formList.current = val;
      this.getSendBuyRePayData();
    },
    handleSizeSendBuyRePay(val) {
      this.formList.size = val;
      this.getSendBuyRePayData();
    },

    // 打榜有礼 领奖记录 查询方法
    // searchAwardFifteen(val){
    //   this.current = 1;
    //   this.formList.current = 1;
    //   this.formList.size = 10;
    //   this.formList.memberNick = val.memberNick;
    //   this.formList.rank = val.rank;
    //   this.formList.prizeType = val.prizeType;
    //   this.formList.status = val.status;
    //   this.formList.createTimeStart = val.createTimeStart;
    //   this.formList.createTimeEnd = val.createTimeEnd;
    //   this.formList.sendTimeStart = val.sendTimeStart;
    //   this.formList.sendTimeEnd = val.sendTimeEnd;
    //   this.formList.pin = val.pin;
    //   this.getWinRecord();
    // },
    // getWinRecord(){
    //   this.loading = true;
    //   this.formList.id = this.formList.activityId;
    //   getWinRecordPage(this.formList)
    //   .then(res => {
    //     this.totalAward = 0;
    //     this.activityTable =[];
    //     if(res.code == 1){
    //       this.activityTable = res.data.records;
    //       this.totalAward = Number(res.data.total);
    //       this.formList.current = Number(res.data.current);
    //       this.loading = false;
    //     }else {
    //       this.$message.error(res.message)
    //     }
    //   })
    // },
    // 打榜有礼 实物奖品 查询方法
    searchGoodRecordsPage(val){
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.deliveryTimeStart = val.deliveryTimeStart;
      this.formList.deliveryTimeEnd = val.deliveryTimeEnd;
      this.formList.sendTimeStart = val.sendTimeStart;
      this.formList.sendTimeEnd = val.sendTimeEnd;
      this.formList.commitAddressFlag = val.commitAddressFlag;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      if(this.rowData.activityType == 39){
        this.formList.status = val.status
      }
      this.getGoodsRecord();
    },
    getGoodsRecord(){
      this.loading = true;
      let fn = getGoodsRecordPage
      if(this.rowData.activityType == 39){
        fn = goodRecords
      }
      fn(this.formList).then(res => {
        this.totalAward = 0;
        this.goodsRecordTable =[];
        if(res.code == 1){
          let tableData = res.data.records;
          this.goodsRecordTable = tableData;
          this.totalAward = Number(res.data.total);
          this.formList.current = Number(res.data.current);
          this.loading = false;
        }else {
          this.$message.error(res.message)
        }
        
      })
    },
    // 打榜有礼实物切换size
    handleGoodsRecordSize(val) {
      this.formList.size = val;
      this.getGoodsRecord();
    },
    // 打榜有礼实物切换current
    handleGoodsRecordCurrent(val) {
      this.formList.current = val;
      this.getGoodsRecord();
    },
    // 打榜有礼领奖记录切换size
    handleFifteenWinRecordSize(val) {
      this.formList.size = val;
      this.getWinRecord();
    },
    // 打榜有礼领奖记录切换current
    handleFifteenWinCurrent(val) {
      this.formList.current = val;
      this.getWinRecord();
    },
    //发放记录
    searchAwardOne(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.unlockOrderId = val.unlockOrderId;
      this.formList.orderState = val.orderState;
      this.formList.isFillAddress = val.isFillAddress
      // 下单抽奖-添加白名单字段
      if(this.rowData.activityType == 19){
        this.formList.isWhite = val.isWhite
      }
      this.winningRecord();
    },
    // 中奖记录 积分锁权 - 派样回购礼
    searchAwardFour(val){
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.mobile = val.mobile;
      this.formList.sendStatus = val.sendStatus;
      this.formList.deliveryStatus = val.deliveryStatus;
      this.formList.createTimeStart = val.createTimeStart;
      this.formList.createTimeEnd = val.createTimeEnd;
      this.formList.sendTimeStart = val.sendTimeStart;
      this.formList.sendTimeEnd = val.sendTimeEnd;
      this.formList.deliveryTimeStart = val.deliveryTimeStart;
      this.formList.deliveryTimeEnd = val.deliveryTimeEnd;

      this.winningRecord();
    },
    //锁权记录
    searchLockRight(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.isPass = val.isPass;
      this.formList.isEnter = val.isEnter;
      this.formList.buyOrderNumMin = val.buyOrderNumMin;
      this.formList.buyOrderNumMax = val.buyOrderNumMax;
      this.formList.buyMoneyMin = val.buyMoneyMin;
      this.formList.buyMoneyMax = val.buyMoneyMax;
      this.formList.createTimeStart = val.createTimeStart;
      this.formList.createTimeEnd = val.createTimeEnd;
      this.lockRightRecord();
    },
    searchTakeGoods(val){
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.inputTimeStart = val.inputTimeStart;
      this.formList.inputTimeEnd = val.inputTimeEnd;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.takeGoodsRecord();
    },
    searchInkind(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick ? val.memberNick : '';
      this.formList.startTime = val.startTime ? val.startTime : '';
      this.formList.endTime = val.endTime ? val.endTime : '';
      this.formList.status = val.status ? val.status : '';
      this.formList.orderId = val.orderId ? val.orderId : '';
      this.formList.orderState = val.orderState ? val.orderState : '';
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : '';
      this.formList.commitAddressFlag = val.commitAddressFlag ;
      this.formList.pin = val.pin;
      this.inKingRecord();
    },
    searchUserInfo(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.improveRecord();
    },
    searchComment(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.orderId = val.orderId;
      this.formList.nickName = val.nickName;
      this.formList.filterType = val.filterType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.commentDraw();
    },
    searchCoupon(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.CoupondDtails();
    },
    searchSplit(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.startTime = val.startTime ? val.startTime + " 00:00:00" : "";
      this.formList.endTime = val.endTime ? val.endTime + " 23:59:59" : "";
      this.CouponStatistics();
    },
    searchGroup(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.startTime = val.startTime ? val.startTime + " 00:00:00" : "";
      this.formList.endTime = val.endTime ? val.endTime + " 23:59:59" : "";
      if (this.fitersChooseIF([31])) {
        this.formList.status = val.status;
      }
      this.TeamDetails();
    },
    // 抽奖机会赠送记录
    giveGiftRecord(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.taskType = val.taskType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.getGameTaskRecord();
    },
    //邀请统计
    searchAwardStatistics(val){
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.unlockOrderId = val.unlockOrderId;
      this.formList.orderState = val.orderState;
      this.formList.isFillAddress = val.isFillAddress
      this.statistics()
    },
    //Note----邀请统计
    statistics(){
      this.loading = true;
      // 只有邀请类的调awardRecNew接口
      if (this.rowData.activityType == 5 || this.rowData.activityType == 6) {
        invaidStatics(this.formList)
          .then((res) => {
            this.loading = false;
            this.invitationNum = res.data.records;
            this.totalAwardFor = Number(res.data.total);
          })
          .catch((res) => {});
        searchInvite({ id: this.rowData.id }).then((res) => {
          this.isTaskPrize = res.data.ruleDto.isTaskPrize
        })
      }
    },
    // 兑换记录
    getList() {
      this.loading = true;
      getExchangeActivityRecord({...this.formList,venderId:this.loginUserInfo.venderId,dataFrom:2}).then((res) => {
        this.exchangeList = res.data.records;
        this.loading = false;
        this.totalMail = Number(res.data.total);
      });
    },
    //标记发货
    changeShip(row) {
      // let id = row.id;
      this.$confirm("是否标记为发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
        customClass:'reverse-buttons'
      }).then(() => {
        DeliveryStatus(row.id,1)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success(res.message);
              this.getList();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      });
    },
    // 取消发货
    cancelShip(row){
      this.$confirm("是否取消发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
        customClass:'reverse-buttons'
      }).then(() => {
        DeliveryStatus(row.id,1)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success('取消发货成功');
              this.getList();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      });
    },
    // 兑换记录表单查询
    searchFormThir(val) {
      this.formList = {...val,activityId:this.rowData.id};
      this.formList.size = 10;
      this.formList.current = 1;
      this.getList();
    },
    // 中奖记录分页查询
    handlePageAward(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.winningRecord();
    },
    // 实物奖品名单分页
    handlePageInkind(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.inKingRecord();
    },
    // 抽奖机会赠送记录分页
    handlePageGiftrecord({ pageNum, pageSize }) {
      this.formList.size = pageSize;
      this.formList.current = pageNum;
      this.getGameTaskRecord();
    },
    //分页事件
    handleSizeExchange(val) {
      this.formList.size = val;
      this.getList();
    },
    handleCurrentExchange(val) {
      this.formList.current = val;
      this.getList();
    },
    // 领取记录列表
    getRecord(){
      this.loading = true;
      const query = {
        size:this.formListRecord.size,
        current:this.formListRecord.current,
        activityId:this.rowData.id,
      }
      if(this.formListRecord.memberNick){
        query.memberNick = this.formListRecord.memberNick
      }
      if(this.formListRecord.prizeType){
        query.prizeType = this.formListRecord.prizeType
      }
      if(this.formListRecord.status){
        query.status = this.formListRecord.status
      }
      if(this.formListRecord.startTime && this.formListRecord.endTime){
        query.startTime = this.formListRecord.startTime
        query.endTime = this.formListRecord.endTime
      }
      getUnlockRecord(query)
      .then(res => {
        if(res.code == 1){
          this.getRecordList = res.data.records;
          this.totalRecord = Number(res.data.total);
          this.formListRecord.current = Number(res.data.current);
          this.loading = false;
        }else {
          this.$message.error(res.message)
        }
      })
    },
    // 领取记录表单
    searchFormRecord(val) {
      this.formListRecord = {...val,activityId:this.rowData.id};
      this.formListRecord.size = 10;
      this.formListRecord.current = 1;
      this.getRecord();
    },
    //分页事件
    handleSizeExchangeRecord(val) {
      this.formListRecord.size = val;
      this.getRecord();
    },
    handleCurrentExchangeRecord(val) {
      this.formListRecord.current = val;
      this.getRecord();
    },
    // 领取记录标记发放
    recordMark(row){
      signIssuance({ id: row.recordId || row.id })
        .then((res) => {
          if (res && res.code == 1) {
            this.getRecord()
            this.$message.success(res.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((res) => {});
    },
    //邀请明细分页
    handleSizeExchangeStatics(val){
      this.formList1.size = val;
      this.invitationDetailNews();
    },
    handleCurrentExchangeStatics(val) {
      this.formList1.current = val;
      this.invitationDetailNews();
    },
    // 点击解密  name: 修改的字段名   objdata：数组的名称, params:接口的参数  item：点击的对象    index：数组传下标值
    handleDecrypt(name, objdata, item, index) {
      let params = "";
      // 资料明细 userInfoTable  实物奖品 inkindTable
      if (objdata == "userInfoTable") {
        params = "encrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      } else if (objdata == "inkindTable" || objdata == "awardTable"  ) {
        params = "decrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      } else if (objdata == "participateTable") {
        params = "mobile";
      } else{
        params = "decrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      }
      this.$decrypt.decryptJHK({ decryptContent: item[`${params}`] }).then((res) => {
        this[`${objdata}`][index][`${name}`] = res.message;
      });
    },

    // 点击解密
    handleDecrypt1(name, item, index) {
      let params = "encrypt" + name[0].toUpperCase() + name.substring(1, name.length);

      this.$decrypt.decryptJHK({ decryptContent: item[`${params}`] }).then((res) => {
        this.exchangeList[index][`${name}`] = res.message;
      });
    },

    // 折线图 tooltip
    //echarts图表自定义提示框函数
    echartIcon(params) {
      var str = '<div style="font-size:13px;color:#fff;font-weight:500;line-height:1;">' + params[0].name + '</div>'
      params.forEach(item => {
        let value = item.value;
        let seriesName = item.seriesName;
        if (!item.value) {
          value = 0;
        }
        if(this.fitersChooseIF([25, 33, 32, 26])){
          let dataList = ["点击用户下单转化率", "访客加购率", "点击率", "下单-支付转化率", "访客成交转化率"];
          if(dataList.includes(seriesName)){
            value =( value * 100) +'%';
          }
        }
        if(this.fitersChooseIF([37])){
          let dataList = ["收货回购率", "付款回购率",];
          if(dataList.includes(seriesName)){
            value =( value ) +'%';
          }
        }
        str += `<div style="font-size:13px;color::#fff;"><span style="display:inline-block;margin-right:8px;border-radius:20px;width:10px;height:10px;background-color:${item.color};"></span><span style="margin-right:4px">${seriesName}：</span><span style="font-weight:400">${value}</span></div>`
      })
      return str
    },

    //解锁记录
    searchUnlockRecord(val) {
      if(val){
        this.formList.current = 1
        this.formList.pin = val.pin;
        this.formList.giveType = val.giveType;
        this.formList.orderId = val.orderId;
        this.formList.orderState = val.orderState;
        this.formList.isCommitAddress = val.isCommitAddress;
        this.formList.isWin = val.isWin;
        this.formList.startTime = val.startTime;
        this.formList.endTime = val.endTime;
        this.formList.finishStartTime = val.finishStartTime;
        this.formList.finishEndTime = val.finishEndTime;
        this.formList.unLockSource = val.unLockSource;
        this.formList.platformUserName = val.platformUserName;
      }
      this.loading = true;
      checkOrderRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.unlockTable = res.data.records;
          this.totalUnlock = Number(res.data.total);
        })
        .catch((res) => {});
    },
    handlePageUnlock(val) {
      this.formList.current = val.pageNum;
      this.formList.size = val.pageSize;
      this.searchUnlockRecord();
    },
    handleSizeUnlock(val) {
      this.formList.size = val;
      this.searchUnlockRecord();
    },
    handleCurrentUnlock(val) {
      this.formList.current = val;
      this.searchUnlockRecord();
    },
    exportUnlockData(val) {
      let params = {
        ...this.formList,
        exportRemark: val,
        size: 99999,
        venderId:this.loginUserInfo.venderId,
      }
      exportCheckOrderRecord(params).then((res) => {
        if (res.code == 1) {
          // this.control1 = true;
        }else {
          this.$message.error(res.message);
        }
      })
    },
    //赠品记录
    searchGiftRecord(val) {
      if(val) {
        this.formList.current = 1
        this.formList.pin = val.pin;
        this.formList.giveType = val.giveType;
        this.formList.orderId = val.orderId;
        this.formList.prizeType = val.prizeType;
        this.formList.prizeName = val.prizeName;
        this.formList.sendStatus = val.sendStatus;
        this.formList.deliveryStatus = val.deliveryStatus;
        this.formList.joinTimeStart = val.joinTimeStart;
        this.formList.joinTimeEnd = val.joinTimeEnd;
        this.formList.sendStartTime = val.sendStartTime;
        this.formList.sendEndTime = val.sendEndTime;
        this.formList.deliveryTimeStart = val.deliveryTimeStart;
        this.formList.deliveryTimeEnd = val.deliveryTimeEnd;
        this.formList.unLockSource = val.unLockSource;
        this.formList.platformUserName = val.platformUserName;
      }
      this.loading = true;
      this.giftTable = [];
      getWinRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.giftTable = res.data.records;
          this.totalGift = Number(res.data.total);
        })
        .catch((res) => {});
    },
    handlePageGift(val){
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.searchGiftRecord();
    },
    handleSizeGift(val) {
      this.formList.size = val;
      this.searchGiftRecord();
    },
    handleCurrentGift(val) {
      this.formList.current = val;
      this.searchGiftRecord();
    },
    exportGiftData(val) {
      let params = {
        ...this.formList,
        exportRemark: val,
        size: 99999,
        venderId:this.loginUserInfo.venderId,
        convertToProcess: this.convertToProcess? 1 : 0, //是否把导出记录变为处理中
      }
      exportWinRecord(params).then((res) => {
        this.convertToProcess = false;
        setTimeout(() => {
          this.searchGiftRecord();
        },1000)
        if (res.code == 1) {
          // this.control1 = true;
        }else {
          this.$message.error(res.message);
        }
      })
    },
    //收货信息记录
    searchReceptRecord(val) {
      if(val){
        this.formList.current = 1
        this.formList.pin = val.pin;
        this.formList.inputTimeStart = val.inputTimeStart;
        this.formList.inputTimeEnd = val.inputTimeEnd;
      }
      this.loading = true;
      getWinRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.receptTable = res.data.records;
          this.totalRecept = Number(res.data.total);
        })
        .catch((res) => {});
    },
    handlePageRecept(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.searchReceptRecord();
    },
    handleSizeRecept(val) {
      this.formList.size = val;
      this.searchReceptRecord();
    },
    handleCurrentRecept(val) {
      this.formList.current = val;
      this.searchReceptRecord();
    },
    exportReceptData(val) {
      let params = {
        ...this.formList,
        exportRemark: val,
        size: 99999,
        venderId:this.loginUserInfo.venderId,
      }
      exportWinRecord(params).then((res) => {
        if (res.code == 1) {
          // this.control1 = true;
        }else {
          this.$message.error(res.message);
        }
      })
    },
    // 信息参与记录导出
    exportParticipateData(val) {
      let params = {
        ...this.formList,
        exportRemark: val,
        venderId:this.loginUserInfo.venderId,
      }
      exportPlatformImproveRecord(params).then((res) => {
        if (res.code == 1) {
        }else {
          this.$message.error(res.message);
        }
      })
    },
    batchMark(source) {
      if (!this.multipleSelection.length)
        return this.$message.warning("请先勾选有效数据再操作");
      let ids = this.multipleSelection.map((item) => item.id);
      markingSendStatus(source, ids).then((res) => {
        if (res.code == 1) {
          if (source == 2) this.winningRecord();
          this.multipleSelection = [];
          this.$refs.winRecordRef &&
          this.$refs.winRecordRef.handleClearSelection();
          this.$message.success(res.message);
        } else {
          this.$message.warning(res.message);
        }
      });
    },
  },
}